<template>
    <div>
        <LabeledValue class="mb3" heading="Rental ID:">{{transactionDetail.id}}</LabeledValue>
        <LabeledValue class="mb3" heading="Payment Date:">{{transactionDetail.paymentDate | moment("MMM DD [at] h:mma")}}</LabeledValue>
        <LabeledValue class="mb3" heading="Billed To:">
            
            <div>{{transactionDetail.billingName}}</div>
            <div>{{transactionDetail.billingAddress}}</div>
            <div>{{transactionDetail.billingCity}}, {{transactionDetail.billingProvince}} {{transactionDetail.billingPostal}}</div>
        </LabeledValue>
        <LabeledValue class="mb3" heading="Item:">{{transactionDetail.listingTitle}}</LabeledValue>
        <LabeledValue class="mb3" heading="From:">{{transactionDetail.rentalStart | moment("MMM DD [at] h:mma")}}</LabeledValue>
        <LabeledValue class="mb3" heading="To:">{{transactionDetail.rentalEnd | moment("MMM DD [at] h:mma")}}</LabeledValue>
    </div>
</template>

<script>
import LabeledValue from '@/components/controls/LabeledValue.vue';
import { mapState } from 'vuex';

export default {
    components: {
        LabeledValue
    },
    computed: {
        ...mapState('invoices', ['transactionDetail'])
    }
};
</script>
